import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import type { ClassValue } from 'clsx'

// tailwind-merge doesn't know about the project's custom type scale
// (--text-caption/body-sm/body/title-sm/title/display, defined in
// src/styles.css's @theme block), so by default it lumps `text-caption`
// etc. into the same conflict group as `text-{color}` utilities — merging
// e.g. `cn('text-caption', 'text-primary')` silently drops the size class.
// Registering the scale here keeps font-size and text-color independent.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['caption', 'body-sm', 'body', 'title-sm', 'title', 'display'] },
      ],
    },
  },
})

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number with thousands separators
 * @example formatNumber(1234567) => "1,234,567"
 */
export function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(num)
}
